export const API_URL = "https://api.6cardgolf.com";
